import { useState, useEffect, createContext, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { FloatingDock } from './FloatingDock';
import styles from './ManagerLayout.module.css';

// Theme context to share with FloatingDock
interface ThemeContextValue {
  isDark: boolean;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue>({
  isDark: false,
  toggleTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export function ManagerLayout() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('doopl_theme');
    // Default to light mode unless user explicitly chose dark
    return saved === 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    localStorage.setItem('doopl_theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <div className={styles.layout}>
        <main className={styles.main}>
          <Outlet />
        </main>
        <FloatingDock />
      </div>
    </ThemeContext.Provider>
  );
}
